import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import * as Icon from 'ubs-icons';
import {COLOR} from "ubs-framework/v2/common/constant";
import {createCookie, getCookie} from "ubs-framework/v2/common/function";
import {sendData} from '../../../store/actions';

export default function (ComposedComponent) {
    class NetworkDetector extends Component {
        state = {
            isDisconnected: false,
            back: false,
        };

        componentDidMount() {
            window.addEventListener('focus', this.onFocus);
            window.addEventListener('online', this.handleConnectionChange);
            window.addEventListener('offline', this.handleConnectionChange);
        }

        componentWillUnmount() {
            window.removeEventListener('focus', this.onFocus);
            window.removeEventListener('online', this.handleConnectionChange);
            window.removeEventListener('offline', this.handleConnectionChange);
        }

        handleConnectionChange = () => {
            if (navigator.onLine) {
                this.setState({back: true, isDisconnected: false});
                const orgId = window.location.pathname.split('/')[1];
                let data = {};
                if (orgId.length === 10) data = {token: getCookie('ubs_token'), orgId};
                else data = {token: getCookie('ubs_token')};
                if (data?.token?.length) sendData('authenticate', data);
                else {
                    if (window.location.pathname !== '/logout') createCookie('previousURL', window.location.href);
                    window.location.href = process.env.REACT_APP_ACCOUNT_MODULE_URL;
                }
            } else {
                this.setState({back: false, isDisconnected: true});
            }
        };
        doRefresh = () => {
            window.location.reload(true);
        };

        onFocus = () => {
            if (this.props._ORG_ID.length !== 0) createCookie(this.props._ORG_ID, this.props._TAB_ID);
        };

        render() {
            const {isDisconnected, back} = this.state;
            return (
                <div className="u_h-full">
                    <div className={`u_access-bar ${isDisconnected && 'u_active'}`}>
                        {isDisconnected && (<div className={back === true ? 'u_top-bar u_bar-active' : 'u_top-bar'}>
                            <p className="u_topbar-title">
                                {!back && <React.Fragment>
                                    <Icon.NoInternet size={20} fill={COLOR.u_white} className="u_mr-10"/>Internet connection lost
                                </React.Fragment>}

                                {back && <React.Fragment>
                                    <span className="">Internet connection restored</span>
                                    <span className="" onClick={this.doRefresh.bind(this)}> </span>
                                </React.Fragment>
                                }
                            </p>
                        </div>)
                        }
                    </div>
                    <ComposedComponent {...this.props}/>
                </div>
            );
        }
    }

    function mapStateToProps(state) {
        return {
            _TAB_ID: state.common.tabId,
            _ORG_ID: state.common.orgId,
        };
    }

    return connect(mapStateToProps, null)(withRouter(NetworkDetector));
}
